import {
  VideoTrack,
  TrackRefContext,
  type TrackReference,
} from '@livekit/components-react'

interface VideoTrackDisplayProps {
  tracks: TrackReference[]
}

export function VideoTrackDisplay({ tracks }: VideoTrackDisplayProps) {
  if (tracks.length === 0) {
    return null
  }

  return (
    <>
      {tracks.map(trackRef => (
        <TrackRefContext.Provider
          key={trackRef.publication.trackSid}
          value={trackRef}
        >
          <VideoTrack
            trackRef={trackRef}
            className="w-full h-full object-cover"
          />
        </TrackRefContext.Provider>
      ))}
    </>
  )
}
